




























































































import { Component, Vue } from 'vue-property-decorator'
import * as Reveal from '@/assets/scripts/RevealOnScrollModule'

@Component
export default class Cookiebox extends Vue {

	data() {
		return {
			PageTitle: "Cookiebox"
		}
	}
	mounted() {
		new Reveal.revealOnScrollModule()
	}
}
